const moneda = {
    "54": "ARS",  // Argentina (Peso Argentino)
    "591": "BOB",  // Bolivia (Bolivianos)
    "55": "BRL",  // Brasil (Real)
    "56": "CLP",  // Chile (Peso Chileno)
    "57": "COP",  // Colombia (Peso Colombiano)
    "506": "CRC",  // Costa Rica (Colón Costarricense)
    "53": "CUP",  // Cuba (Peso Cubano)
    "593": "USD",  // Ecuador (Dólar Estadounidense)
    "503": "USD",  // El Salvador (Dólar Estadounidense)
    "502": "GTQ",  // Guatemala (Quetzal Guatemalteco)
    "504": "HNL",  // Honduras (Lempira)
    "52": "MXN",  // México (Peso Mexicano)
    "505": "NIO",  // Nicaragua (Córdoba)
    "507": "PAB",  // Panamá (Balboa)
    "595": "PYG",  // Paraguay (Guaraní)
    "51": "PEN",  // Perú (Nuevo Sol)
    "1": "DOP",  // República Dominicana (Peso Dominicano)
    "598": "UYU",  // Uruguay (Peso Uruguayo)
    "58": "VES"  // Venezuela (Bolívar Soberano)
};
const validarCurrency = (phone) => {
    var tres = phone ? phone.toString().substring(1, 4):'S/D';
    var dos = tres.slice(0, -1);
    var uno = dos.slice(0, -1);

    var currency = '';

    if (moneda[tres]) {
        currency = moneda[tres];
    } else if (moneda[dos]) {
        currency = moneda[dos];
    } else if (moneda[uno]) {
        currency = moneda[uno];
    } else {
        // console.log('POR AQUI');
        currency = '$';
    }

  return currency;
};
export {validarCurrency}